export function formatRelativeTime(
  dateInput: string | Date | null | undefined,
  now: Date = new Date(),
): string {
  if (!dateInput) return 'Never';

  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return 'Unknown';

  const diffMs = now.getTime() - date.getTime();
  const absMs = Math.abs(diffMs);
  const future = diffMs < 0;

  const seconds = Math.floor(absMs / 1000);
  if (seconds < 45) return future ? 'in a moment' : 'just now';

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    const label = minutes === 1 ? '1 min' : `${minutes} mins`;
    return future ? `in ${label}` : `${label} ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const label = hours === 1 ? '1 hr' : `${hours} hrs`;
    return future ? `in ${label}` : `${label} ago`;
  }

  const days = Math.floor(hours / 24);
  if (days < 30) {
    const label = days === 1 ? '1 day' : `${days} days`;
    return future ? `in ${label}` : `${label} ago`;
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    const label = months === 1 ? '1 mo' : `${months} mos`;
    return future ? `in ${label}` : `${label} ago`;
  }

  const years = Math.floor(months / 12);
  const label = years === 1 ? '1 yr' : `${years} yrs`;
  return future ? `in ${label}` : `${label} ago`;
}

export function formatAbsoluteDateTime(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return 'Never';
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return 'Unknown';
  return `${formatAbsoluteDate(dateInput)} ${formatAbsoluteTime(dateInput)}`;
}

export function formatAbsoluteDate(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return 'Never';
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return 'Unknown';
  return date.toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function formatAbsoluteTime(dateInput: string | Date | null | undefined): string {
  if (!dateInput) return '';
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(undefined, { timeStyle: 'medium' });
}
